const WIDGET = '.dropdown'
const ACTIVECLASS = 'is-open'
const MOBILE_BP = 1024

export class Dropdown {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET)
  }

  init = () => {
    this.elements.forEach((el) => {
      const button = el.querySelector('.dropdown__btn')
      if (button) {
        button.addEventListener('click', this.clickHandler, false)
      }
    })
  }

  clickHandler = (e) => {
    if (window.innerWidth > MOBILE_BP) return

    const button = e.currentTarget
    const widget = button.closest(WIDGET)

    if (!widget.classList.contains(ACTIVECLASS)) {
      this.closeActive()
    }

    widget.classList.toggle(ACTIVECLASS)
  }

  closeActive = () => {
    const openDropdown = document.querySelector(`${WIDGET}.${ACTIVECLASS}`)
    if (openDropdown) {
      openDropdown.classList.remove(ACTIVECLASS)
    }
  }
}

const dropdown = new Dropdown()
dropdown.init()
